import type { PickerOption } from "@/lib/liveavatar/options";

export const DID_BACKGROUND_NONE = "none";
/** Id used for a trainer-uploaded background; the URL lives on the scenario. */
export const DID_BACKGROUND_CUSTOM = "custom";

export type DidBackground = {
  id: string;
  label: string;
  /**
   * Absolute, anonymously reachable https image URL. D-ID fetches the image
   * from its own servers, so it must not depend on this deployment's origin.
   */
  url?: string;
};

export const DID_BACKGROUNDS: DidBackground[] = [
  { id: DID_BACKGROUND_NONE, label: "None" },
  {
    id: "office",
    label: "Open-plan office",
    url: "https://lovable-apps-static.s3.us-east-1.amazonaws.com/open-office.jpg",
  },
  {
    id: "conference_room",
    label: "Conference room",
    url: "https://lovable-apps-static.s3.us-east-1.amazonaws.com/conference-room.jpg",
  },
  {
    id: "home_office",
    label: "Home office",
    url: "https://lovable-apps-static.s3.us-east-1.amazonaws.com/home-office.jpg",
  },
  {
    id: "reception",
    label: "Hotel reception",
    url: "https://lovable-apps-static.s3.us-east-1.amazonaws.com/reception-lounge.jpg",
  },
  {
    id: "cafe",
    label: "Coworking cafe",
    url: "https://lovable-apps-static.s3.us-east-1.amazonaws.com/coworking-cafe.jpg",
  },
];

export function didBackground(id?: string): DidBackground | undefined {
  if (!id) return undefined;
  return DID_BACKGROUNDS.find((b) => b.id === id);
}

/** Absolute URL for a background id, or undefined for "none" / unknown ids. */
export function resolveDidBackgroundUrl(id?: string, customUrl?: string): string | undefined {
  if (id === DID_BACKGROUND_CUSTOM) return customUrl?.trim() || undefined;
  return didBackground(id)?.url;
}

/** URL used for in-app previews (editor tiles, trainer card thumbnails). */
export function didBackgroundPreview(id?: string, customUrl?: string): string | undefined {
  if (id === DID_BACKGROUND_CUSTOM) return customUrl?.trim() || undefined;
  return didBackground(id)?.url;
}

export const DID_BACKGROUND_OPTIONS: PickerOption[] = DID_BACKGROUNDS.map((b) => ({
  id: b.id,
  label: b.label,
}));

/** Tile options for the visual background picker (includes previews). */
export const DID_BACKGROUND_TILES: PickerOption[] = DID_BACKGROUNDS.map((b) => ({
  id: b.id,
  label: b.label,
  preview_url: b.url,
}));
